import React, { useEffect, useState } from 'react'
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

import { API } from '../../../backend';

const ExitingCheckout = ({
  userData,
  updatestate,
  paymentintentid,
  isLoading,
  setIsLoading,
  company_name,
  name,
  email,
  phone_number,
  address,
  country,
  state,
  city,
  zip_code,
  userAllow,
  userallowed,
  amount,
  start_date,
  end_date,
  setAdduser,
  setUpgrade,
  companydata,
  value,
  paymentid
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [data, setData] = useState([])
  const [companyUsers, setCompanyUsers] = useState(0)
  const [ipAddress, setIPAddress] = useState('')
  const [totalUser, setTotalUser] = useState(0)

  useEffect(() => {
    if (!stripe) {
      return;
    }
    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );
    if (!clientSecret) {
      return;
    }
    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Please log a support ticket or send email to support@athenafintech.com.");
          break;
      }
    })
  }, [stripe]);

  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        setIPAddress(data.ip);
        handlepaymentintentupdate(data.ip); // Call handlepaymentintentupdate with the IP address
      })
      .catch(error => console.log(error));
    // }
    setCompanyUsers(parseInt(companydata.userallow))
  }, [
    company_name,
    name,
    phone_number,
    email,
    address,
    country,
    state,
    city,
    zip_code,
    ipAddress,
    userAllow,
    amount,
    companyUsers,

  ]);

const currentUrl = window.location.origin;


  const handlepaymentintentupdate = async () => {
    try {
      const body = {
        paymentintent_id: paymentintentid,
        companyName: company_name,
        name: name,
        phoneNumber: phone_number,
        email: email,
        address: address,
        country_name: country,
        stateName: state,
        city: city,
        zipCode: zip_code,
        ipAddress: ipAddress,
        userallow: totalUser,
        amount: amount * 100,
        start_date: start_date,
        end_date: end_date,
        add_user:userAllow
      }
      const response = await fetch(API + 'accounting/update-payment-intent/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setData(data)
    }
    catch (error) {
      console.error('Error fetching client secret:', error);
    }
  }
  useEffect(() => {
    if(value === 'addUser'){
      const user = parseInt(userAllow)
      const companyUserData = parseInt(userallowed)
      const companyUser =companyUserData  + user
      setTotalUser(companyUser)
    }else{
      setTotalUser(userAllow)
    }
  }, [companyUsers, userallowed,userAllow,value])

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);
    const { error } = await stripe.confirmPayment({
      elements,

      confirmParams: {
        return_url: currentUrl+`/confirmexisting?value=${value}&session_id=${paymentid}`,
      },
    });

    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }
    setIsLoading(false);
    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs",
  }
  const handleCancel = () => {
    setUpgrade(false)
    setAdduser(false)
  }
  return (
    <form id="payment-form" onSubmit={handleSubmit}>

      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <div style={{ marginTop: '1rem' }}>
        <button className="btn btn-danger mt-3" onClick={() => handleCancel()} style={{ marginRight: '10px' }}>
          Cancel
        </button>
        <button className="btn btn-primary mt-3 " disabled={isLoading || !stripe || !elements} id="submit">
          <span id="button-text">
            {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
          </span>
        </button>
      </div>
      {message && <div id="payment-message">{message}</div>}
    </form>
  )
}

export default ExitingCheckout